import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function HeartIcon(props: IIcon) {
    return (
        <Icon
            dropShadow={props.dropShadow}
            width={props.width}
            height={props.height}
            viewBox={props.viewBox ?? '0 0 24 22'}
            style={props.style}
            className={props.className}
        >
            <path
                id="heart"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.95799 11.7291C0.704128 10.4407 0 8.69934 0 6.88373C0 5.05805 0.711538 3.30661 1.97899 2.01567C3.24644 0.724737 4.96602 0 6.75849 0C8.55095 0 10.2705 0.724737 11.538 2.01567L12 2.48625L12.462 2.01567C13.7295 0.724737 15.4478 0 17.2403 0C19.034 0 20.7523 0.724737 22.0198 2.01567C23.2872 3.30661 24 5.05805 24 6.88373C24 8.69934 23.2959 10.4407 22.0408 11.7291L12.8721 21.6175C12.6461 21.8616 12.3298 22 12 22C11.6702 22 11.3539 21.8616 11.1279 21.6175L1.95799 11.7291ZM12 18.9979L20.2989 10.0482L20.3237 10.023C21.1402 9.19005 21.5998 8.06142 21.5998 6.88373C21.5998 5.70603 21.1402 4.57741 20.3237 3.74447C19.5059 2.91153 18.3965 2.44346 17.2403 2.44346C16.0852 2.44346 14.9759 2.91153 14.1581 3.74447L12.8487 5.07944C12.3793 5.5563 11.6195 5.5563 11.1513 5.07944L9.84063 3.74447C9.02408 2.91153 7.91476 2.44346 6.75849 2.44346C5.60222 2.44346 4.49413 2.91153 3.67634 3.74447C2.85855 4.57741 2.40024 5.70603 2.40024 6.88373C2.40024 8.06142 2.85855 9.19005 3.67634 10.023C3.68499 10.0318 3.6924 10.0393 3.69981 10.0482L12 18.9979Z"
                fill="currentColor"
            />
        </Icon>
    );
}
